var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsolidationUnionCreateAdmin',{attrs:{"CU":_vm.CU,"warehousesData":_vm.warehousesData,"statesData":_vm.statesData,"shippingCompanies":_vm.shippingCompanies},on:{"saveConsolidationUnion":_vm.saveConsolidationUnion}})
}
var staticRenderFns = []

export { render, staticRenderFns }